<template>
	<div>
		<v-row>
			<v-col cols="12" md="6">
				<v-autocomplete
					v-model="selectedTaxexemption"
					:items="filteredExemptionOptions"
					label="Exemption options"
					multiple
					chips
					return-object
					:disabled="disabled"
					@change="(...args) => emitSelectedValue('taxExemption',...args)"
				></v-autocomplete>
			</v-col>
			<v-col cols="12" md="6">
				<!-- arrival by -->
				<generic-autocomplete
					:api="api.arrivalBy.basePart"
					:label="txt.labels.arrivalBy"
					:queryProps="api.arrivalBy.props"
					:queryPropValues="[this.selectedMandatorId]"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('arrivalBy',...args)"
					@loading="(...args) => this.emitLoadingVariables('arrivalBy',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('arrivalBy',...args)"
				/>
			</v-col>
		</v-row>
		<v-row>
			<!-- serviceprovider city -->
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.spCity.basePart"
					:queryProps="api.spCity.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.spCity"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('spCity',...args)"
					@loading="(...args) => this.emitLoadingVariables('spCity',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('spCity',...args)"
				/>
			</v-col>
			<!-- serviceprovider accomodation type -->
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.spAccommodationType.basePart"
					:label="txt.labels.spAccommodationType"
					:queryProps="api.spAccommodationType.props"
					:queryPropValues="[this.selectedMandatorId]"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:groupingEffect="true"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('spAccommodationType',...args)"
					@loading="(...args) => this.emitLoadingVariables('spAccommodationType',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('spAccommodationType',...args)"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="6">
				<!-- reseller partner -->
				<generic-autocomplete
					:api="api.resellerPartner.basePart"
					:label="txt.labels.resellerPartner"
					:queryProps="api.resellerPartner.props"
					:queryPropValues="[this.selectedMandatorId]"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('resellerPartner',...args)"
					@loading="(...args) => this.emitLoadingVariables('resellerPartner',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('resellerPartner',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<!-- reseller partner user -->
				<generic-autocomplete
					:api="api.resellerPartnerUser.basePart"
					:label="txt.labels.resellerPartnerUser"
					:queryProps="api.resellerPartnerUser.props"
					:queryPropValues="[this.selectedMandatorId]"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('resellerPartnerUser',...args)"
					@loading="(...args) => this.emitLoadingVariables('resellerPartnerUser',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('resellerPartnerUser',...args)"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.hestaNationality.basePart"
					:label="txt.labels.hestaNationality"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					:show="showHesta"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('hestaNationality',...args)"
					@loading="(...args) => this.emitLoadingVariables('hestaNationality',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('hestaNationality',...args)"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import GenericAutocomplete from '../../arcCustom/filters/GenericAutocomplete.vue'

export default {
	components: {
		GenericAutocomplete,
	},
	props: {
		appNameShort: {
			type: String,
			required: true,
		},
		selectedMandatorId: {
			type: Number,
			required: true,
		},
		openCloseCounter: {
			type: Number,
			default: 9999,
		},
		disabled: {
			type: Boolean,
			required: true,
		},
		selectedNationalitiesIso: {
			type: Array,
		},
	},
	watch: {
		selectedMandatorId: {
			handler() {
				this.setExemptionOptions()
				this.renderForce()
			},
		},
	},
	data() {
		return {
			openCloseCounterLocal: this.openCloseCounter,
			selectedTaxexemption: {},
			filteredExemptionOptions: [],
			selectedMandatorIdLocal: this.selectedMandatorId,
			selectedNationalitiesHesta: [],
			txt: {
				labels: {
					spCity: 'Serviceprovider city',
					spAccommodationType: 'Serviceprovider accomodation type',
					resellerPartner: 'B2B Partner',
					resellerPartnerUser: 'B2B Partner User',
					arrivalBy: 'Arrival by',
					hestaNationality: 'Nationality as HESTA',
				},
			},
			api: {
				spCity: {
					basePart: '/registration-report/form-serviceproviders-city',
					props: [{ name: 'installationid', value: 9999 }],
				},
				spAccommodationType: {
					basePart: '/registration-report/form-serviceproviders-accommodation-type',
					props: [{ name: 'installationid', value: 9999 }],
				},
				resellerPartner: {
					basePart: '/registration-report/form-reseller-partner',
					props: [{ name: 'installationid', value: 9999 }],
				},
				resellerPartnerUser: {
					basePart: '/registration-report/form-reseller-user',
					props: [{ name: 'installationid', value: 9999 }],
				},
				arrivalBy: {
					basePart: '/registration-report/form-arrival-by',
					props: [{ name: 'installationid', value: 9999 }],
				},
				hestaNationality: {
					basePart: '/registration-report/hesta',
					props: [{ name: 'installationid', value: 9999 }],
				},
			},
		}
	},
	computed: {
		showHesta() {
			// eslint-disable-next-line max-len
			if (this.selectedNationalitiesIso.length == 0 && this.selectedNationalitiesHesta.length == 0) return true
			return !(this.selectedNationalitiesIso.length > 0)
		},
	},
	methods: {
		renderForce() {
			this.openCloseCounterLocal += 1
		},
		setExemptionOptions() {
			// reset the selected exemption option due different logic for different mandators
			this.selectedTaxexemption = []
			this.filteredExemptionOptions = [
				{ text: 'visitor tax exemption', value: 2 },
				{ text: 'no exemption', value: 3 },
			]

			if (this.selectedMandatorId == 7) {
				// removes the accomodation tax exemption
				this.filteredExemptionOptions.splice(0, 1)
			}
			return this.filteredExemptionOptions
		},
		emitSelectedValue(filterId, values) {
			const emittedObject = {
				filterId,
				values,
			}
			if (emittedObject.filterId == 'hestaNationality') this.handleHestaShowing(values)
			this.$emit('emitSelectedValue', emittedObject)
		},
		emitLoadingVariables(filterId, value) {
			const emittedObject = {
				filterId,
				value,
			}
			this.$emit('emitLoadingVariables', emittedObject)
		},
		emitErrorEvent(filterId, value) {
			const emittedObject = {
				filterId,
				value,
			}
			this.$emit('emitErrorEvent', emittedObject)
		},
		handleHestaShowing(value) {
			this.selectedNationalitiesHesta = value
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.setExemptionOptions()
			this.renderForce()
		})
	},
}
</script>

<style scoped>
.secondaryRegistrationReportFilters {
	background-color: #d5d5d5;
}

</style>
